function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import pick from 'lodash/pick';
import merge from 'lodash/merge';
import { getListingUseType, ListingTypeByPageContext, PropertyStatus, SaleMethod, TitanAdKey, TitanAdKeyCat1Values, TitanAdKeyCtypeValues, wordWrap } from '@domain-group/fe-allhomes-library';
var constants = {
  BEDS_RANGE_MAX: 5,
  BATHS_RANGE_MAX: 5,
  PARKING_RANGE_MAX: 5
};
var capitalizeFirstLetter = string => string && string.charAt(0).toUpperCase() + string.slice(1);
var SortRepresentations = {
  AUCTION: 'CLOSEST_AUCTION',
  ADDRESS: 'LOCATION',
  DATEUPDATED: 'LISTING_AGE',
  UPDATED: 'UPDATED',
  DISTANCE: 'DISTANCE',
  BEDROOMS: 'BEDROOMS',
  PRICE: 'PRICE',
  INSPECTIONTIME: 'CLOSEST_EXHIBITION',
  PEOPLEWANTED: 'PEOPLE_WANTED',
  PROPERTYTYPE: 'PROPERTY_TYPE',
  ROOMSAVAILABLE: 'ROOMS_AVAILABLE'
};
var ListedDateRepresentations = {
  TODAY: 'Today',
  YESTERDAY: 'Yesterday',
  WITHIN_LAST_WEEK: 'Within last week',
  SPECIFIC_DATE: 'Specific date'
};
function rangeToString(rangeParam, max) {
  var range = rangeParam || {};
  if (!range.min && !range.max) {
    return 'Any';
  }
  var rangeStart = range.min || 1;
  var rangeStop = range.max || max;
  var rangeItems = [];
  for (var index = rangeStart; index <= rangeStop; index += 1) {
    rangeItems.push(index);
  }
  return rangeItems.join(',');
}
var findLocalityType = type => {
  var findThisLocalityType = locality => {
    if (locality.type === type) {
      return locality;
    }
    return locality.parent ? findThisLocalityType(locality.parent) : null;
  };
  return findThisLocalityType;
};
var findRegion = findLocalityType('REGION');
var findDistrict = findLocalityType('DISTRICT');
var getLocalities = (localities, type) => localities.filter(locality => locality.type === type);
var getDivision = localities => localities.length === 1 && localities[0].type === 'DIVISION' ? localities[0] : undefined;
var makeAdKeySafe = adKey => adKey ? adKey.replace(/'/g, '_').toLowerCase() : '';
var selectedValue = (field, requested) => field && field.selected && field.selected.includes(requested) ? 'true' : 'false';
var rangeField = (label, value) => value ? _objectSpread(_objectSpread({}, value.min && {
  ["".concat(label, "From")]: value.min.toString()
}), value.max && {
  ["".concat(label, "To")]: value.max.toString()
}) : {};
var wrappedField = (label, fieldValue) => {
  var rows = wordWrap(fieldValue.filter(each => each));
  var result = {};
  rows.forEach((row, index) => {
    result["".concat(label).concat(index > 0 ? index : '')] = row;
  });
  return result;
};
var mapDigitalData = function mapDigitalData(filter) {
  var digitalDataKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'label';
  return filter ? filter.available.filter(each => filter.selected.includes(each.name)).map(each => each[digitalDataKey]) : [];
};
var getDivisionPostcodes = localities => getLocalities(localities, 'DIVISION').map(division => division.metaData ? division.metaData.postcode : undefined).filter(postcode => postcode);
var spacedValue = value => value ? " ".concat(value) : '';
var canonicalLocation = location => "".concat(location.name).concat(location.metaData ? "".concat(spacedValue(location.metaData.state)).concat(spacedValue(location.metaData.postcode)) : '');
var buildCanonicalSearchAreas = localities => localities.filter(each => ['REGION', 'DISTRICT', 'DIVISION', 'SCHOOL'].includes(each.type)).map(locality => canonicalLocation(locality));
var hasType = (localities, type) => localities.some(locality => locality.type === type);
function getLocationAreas(localities) {
  var areas = localities.map(locality => {
    if (locality.type === 'DIVISION') {
      return locality.parent ? locality.parent.name : null;
    }
    if (locality.type === 'DISTRICT' || locality.type === 'REGION') {
      return locality.name;
    }
    return '';
  }).reduce((acc, currValue) => {
    if (currValue && acc.indexOf(currValue) < 0) {
      acc.push(currValue);
    }
    return acc;
  }, []);
  return areas.filter(area => area);
}
var buildLocationInfo = localities => {
  var division = getDivision(localities);
  var state = division && division.metaData ? division.metaData.state : undefined;
  var postcodes = getLocalities(localities, 'POSTCODE').map(postcode => postcode.id.toString());
  var divisionPostcodes = getDivisionPostcodes(localities);
  return {
    divisions: getLocalities(localities, 'DIVISION'),
    division,
    state,
    postcodesList: [...postcodes, ...divisionPostcodes],
    searchRegion: division ? (findRegion(division) || {}).name : undefined,
    searchDistrict: division ? (findDistrict(division) || {}).name : undefined,
    searchAreas: getLocationAreas(localities),
    searchLocationCategories: [...(hasType(localities, 'STREET') ? ['Street'] : []), ...(hasType(localities, 'DIVISION') ? ['Suburb'] : []), ...(hasType(localities, 'DISTRICT') ? ['District'] : []), ...(hasType(localities, 'REGION') ? ['Region'] : []), ...(hasType(localities, 'POSTCODE') ? ['Postcode'] : []), ...(hasType(localities, 'SCHOOL') ? ['School Catchment'] : [])],
    canonicalSearchAreas: buildCanonicalSearchAreas(localities)
  };
};
var buildLocationData = locationInfo => ({
  searchTerm: locationInfo.canonicalSearchAreas.join('|'),
  state: locationInfo.state,
  postcode: locationInfo.postcodesList.join(','),
  searchSuburb: locationInfo.division ? locationInfo.division.name : undefined,
  searchRegion: locationInfo.searchRegion,
  searchArea: locationInfo.searchAreas.join(','),
  searchLocationCat: locationInfo.searchLocationCategories.join(',')
});
var buildSearchData = filters => {
  var _filters$keywords$val;
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
    bedrooms: rangeToString(filters.beds.value, constants.BEDS_RANGE_MAX),
    bathrooms: rangeToString(filters.baths.value, constants.BATHS_RANGE_MAX),
    carSpaces: rangeToString(filters.parking.value, constants.PARKING_RANGE_MAX),
    listingAge: 'Anytime'
  }, rangeField('price', filters.price.value)), wrappedField('propertyType', mapDigitalData(filters.propertyTypes))), wrappedField('propertyFeatures', filters.listingFeatures ? filters.listingFeatures.selected : [])), rangeField('blockSize', filters.blockSize.value)), rangeField('dwellingSize', filters.floorArea.value)), {}, {
    includeSold: selectedValue(filters.propertyStatus, PropertyStatus.SOLD.name),
    includePrivateTreaty: selectedValue(filters.saleMethods, SaleMethod.PRIVATE_TREATY.name),
    includeEOI: selectedValue(filters.saleMethods, SaleMethod.EXPRESSION_OF_INTEREST.name),
    includeAuctions: selectedValue(filters.saleMethods, SaleMethod.AUCTION.name),
    includeTenders: selectedValue(filters.saleMethods, SaleMethod.TENDER.name),
    showPriceOnly: Boolean(filters.onlyWithPrice),
    keywords: (_filters$keywords$val = filters.keywords.value) !== null && _filters$keywords$val !== void 0 ? _filters$keywords$val : ''
  });
};
var buildTitan = (listingType, locationInfo, localities, hostName) => {
  var _listingType$category, _getListingUseType;
  var pageContext = listingType.pageContext ? ListingTypeByPageContext[listingType.pageContext] : undefined;
  var titanAdKey = pageContext ? TitanAdKey[pageContext] : undefined;
  var adZoneContext = (_listingType$category = listingType.category) === null || _listingType$category === void 0 ? void 0 : _listingType$category.toLowerCase();
  var adZoneUseType = (_getListingUseType = getListingUseType(listingType)) === null || _getListingUseType === void 0 ? void 0 : _getListingUseType.toLowerCase();
  var states = new Set();
  localities.forEach(item => {
    var _item$metaData;
    return ((_item$metaData = item.metaData) === null || _item$metaData === void 0 ? void 0 : _item$metaData.state) && states.add(item.metaData.state);
  });
  return {
    adZone: "".concat(adZoneContext, "/searchresults/").concat(adZoneUseType),
    adKeyValues: {
      cat: titanAdKey === null || titanAdKey === void 0 ? void 0 : titanAdKey.cat,
      cat1: TitanAdKeyCat1Values.SEARCH_RESULTS,
      cat2: titanAdKey === null || titanAdKey === void 0 ? void 0 : titanAdKey.cat2,
      ctype: TitanAdKeyCtypeValues.INDEX,
      locsuburb: locationInfo.divisions.map(suburb => makeAdKeySafe(suburb.name)),
      searchlocationcat: locationInfo.searchLocationCategories.join(',').toLowerCase(),
      locpostcode: locationInfo.postcodesList,
      usertype: titanAdKey === null || titanAdKey === void 0 ? void 0 : titanAdKey.cat,
      locstate: states.size === 1 ? [...states][0].toLowerCase() : undefined,
      locarea: getLocationAreas(localities).map(area => makeAdKeySafe(area)).join(','),
      e: hostName
    },
    adSlots: []
  };
};
var buildCategory = (listingType, newListings) => {
  var _listingType$category2, _getListingUseType2;
  return {
    primaryCategory: capitalizeFirstLetter((_listingType$category2 = listingType.category) === null || _listingType$category2 === void 0 ? void 0 : _listingType$category2.toLowerCase()),
    subCategory1: "Browse ".concat(newListings ? 'New Listings' : 'Results'),
    subCategory2: capitalizeFirstLetter((_getListingUseType2 = getListingUseType(listingType)) === null || _getListingUseType2 === void 0 ? void 0 : _getListingUseType2.toLowerCase()),
    pageType: 'Search Page'
  };
};
var getPageName = (listingType, division, filters) => {
  var _filters$propertyStat, _filters$propertyStat2;
  var usePastLabelIfAvailable = filters === null || filters === void 0 ? void 0 : (_filters$propertyStat = filters.propertyStatus) === null || _filters$propertyStat === void 0 ? void 0 : (_filters$propertyStat2 = _filters$propertyStat.selected) === null || _filters$propertyStat2 === void 0 ? void 0 : _filters$propertyStat2.includes(PropertyStatus.SOLD.name);
  if (usePastLabelIfAvailable && listingType.labelPast) {
    return "".concat(division ? "".concat(division.name, " - ") : '').concat(listingType.labelPast, " Search | allhomes");
  }
  return "".concat(division ? "".concat(division.name, " Real Estate ").concat(listingType.titleFlavour) : "".concat(listingType.label, " Search"), " | allhomes");
};
var buildResultsData = (searchResults, totalPages) => {
  var listingIds = [];
  var agencyIds = {};
  searchResults.forEach(listing => {
    listingIds.push(listing.listing.id);
    agencyIds[listing.agency.id] = true;
  });
  return _objectSpread(_objectSpread({
    searchResultCount: (searchResults ? searchResults.length : 0).toString(),
    resultsPages: totalPages ? totalPages.toString() : undefined
  }, wrappedField('agencyIds', Object.keys(agencyIds))), wrappedField('resultsRecords', listingIds));
};
var buildSchoolCatchmentSubcategory = localities => {
  var _school$metaData;
  var school = localities.find(each => each.type === 'SCHOOL');
  return school ? {
    schoolInfo: {
      hasCatchment: Boolean((_school$metaData = school.metaData) === null || _school$metaData === void 0 ? void 0 : _school$metaData.isCatchment)
    }
  } : {};
};
export var buildDigitalData = function buildDigitalData(query, listingType) {
  var searchResults = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var totalPages = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  var hostName = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
  try {
    var _query$filters$getLoc, _query$filters, _query$sort$value, _query$sort$value2;
    var localities = Array.isArray(query.filters.localities) ? query.filters.localities : (_query$filters$getLoc = (_query$filters = query.filters).getLocalities) === null || _query$filters$getLoc === void 0 ? void 0 : _query$filters$getLoc.call(_query$filters);
    var locationInfo = buildLocationInfo(localities);
    var digitalData = {
      page: _objectSpread({
        pageInfo: {
          search: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, buildLocationData(locationInfo)), buildSearchData(query.filters)), buildResultsData(searchResults, totalPages)), {}, {
            searchTypeView: query.isMapSearch() ? 'Map View' : 'List View',
            searchDepth: '1',
            sortBy: (_query$sort$value = query.sort.value) !== null && _query$sort$value !== void 0 && _query$sort$value.criteria ? SortRepresentations[(_query$sort$value2 = query.sort.value) === null || _query$sort$value2 === void 0 ? void 0 : _query$sort$value2.criteria] : undefined,
            listedDate: query.filters && query.filters.listedDate.value ? ListedDateRepresentations[query.filters.listedDate.value.type] : undefined
          }),
          pageName: getPageName(listingType, locationInfo.division, query.filters)
        },
        category: buildCategory(listingType, query.isNewListings())
      }, buildSchoolCatchmentSubcategory(localities)),
      titan: buildTitan(listingType, locationInfo, localities, hostName)
    };
    return digitalData;
  } catch (error) {
    console.error('Error building digitalData: ', error);
    return {};
  }
};
export function updateDigitalData(digitalData, query, listingType, searchResults, totalPages, hostName) {
  try {
    var base = pick(digitalData, 'page.pageInfo.brand', 'page.pageInfo.generator', 'page.pageInfo.sysEnv', 'user', 'version', 'events', 'titan.adSite', 'titan.spa', 'titan.adKeyValues.e', 'titan.adKeyValues.locarea', 'titan.adKeyValues.cat3', 'server');
    return merge(base, buildDigitalData(query, listingType, searchResults, totalPages, hostName));
  } catch (error) {
    console.error('Error updating digitalData: ', error);
    return {};
  }
}